const accents = {

    btn: document.getElementById('jsAccentChange') as HTMLElement,
    accents: document.querySelectorAll('.jsAccents') as NodeListOf<HTMLElement>,

    init() {
        this.setAccents()
    },


    setAccents() {
        if(this.btn) {
        this.btn.addEventListener('click', () => {
            this.accents.forEach(accent => {
                accent.classList.toggle('accent-secondary')
               this.btn.classList.toggle('accent-secondary')
            })
        })
    }
    }
}

export default accents;